/**
 * Checks whether value is one of the enum's values.
 */
export function isEnumValue(haystack, needle) {
    return Object.values(haystack).includes(needle);
}
//# sourceMappingURL=utilities-typescript.js.map